import { CURRENCIES_WITH_DUAL_PRICING } from '../const';

export function getExchangeRate(currency: string) {
  return (
    CURRENCIES_WITH_DUAL_PRICING.find((item) => item.currency === currency)
      ?.fixedExchangeRate || 1
  );
}
